<template>
  <div class="freightTates-box">
    <div class="top-block">
      <img class="top-img" src="@/assets/freightTates/top.png" />
      <div class="top-content">
        <p>{{ $t('lang.freightTates.pageTitle') }}</p>
      </div>
    </div>
    <div class="middle-block">
      <transition name="result-fade">
        <div v-if="result" ref="resultBlock" class="result-block">
          <div class="result-header">
            <div class="result-title-wrap">
              <p class="result-subtitle">{{ $t('lang.freightTates.resultTitle') }}</p>
              <p class="result-title">{{ $t('lang.freightTates.pageTitle') }}</p>
            </div>
            <div class="result-price-chip">
              <span>{{ $t('lang.freightTates.priceLabel') }}</span>
              <strong>{{ result.price }}</strong>
            </div>
          </div>
          <div class="result-divider"></div>
          <div class="result-list">
            <div>
              <p class="result-head">{{ $t('lang.freightTates.originLabel') }}</p>
              <p class="result-item">{{ result.originName }}</p>
            </div>
            <div>
              <p class="result-head">{{ $t('lang.freightTates.destinationLabel') }}</p>
              <p class="result-item">{{ result.destinationName }}</p>
            </div>
            <div>
              <p class="result-head">{{ $t('lang.freightTates.weightLabel') }}</p>
              <p class="result-item">{{ result.weight }} KG</p>
            </div>
            <div>
              <p class="result-head">{{ $t('lang.freightTates.volumeLabelResult') }}</p>
              <p class="result-item">{{ result.long }} × {{ result.wide }} × {{ result.tall }} CM</p>
            </div>
            <div>
              <p class="result-head">{{ $t('lang.freightTates.transitTimeLabel') }}</p>
              <p class="result-item">{{ result.transitTime || '-' }}</p>
            </div>
          </div>
        </div>
      </transition>
      <!-- <p class="begin-box">PLACE OF ORIGIN</p> -->
      <div class="begin-block">
        <select v-model="params.begin" class="begin-box" required>
          <option value="" disabled selected hidden>{{ $t('lang.freightTates.originPlaceholder') }}</option>
          <option v-for="origin in filteredOrigins" :key="origin.id" :value="origin.id">
            {{ origin.name }}
          </option>
        </select>
      </div>
      <div class="end-block">
        <select v-model="params.end" class="end-box" required>
          <option value="" disabled selected hidden>{{ $t('lang.freightTates.destinationPlaceholder') }}</option>
          <option v-for="destination in filteredDestinations" :key="destination.id" :value="destination.id">
            {{ destination.name }}
          </option>
        </select>
      </div>
      <div class="volume-block">
        <div class="weight-box">
          <input v-model="params.weight" class="weight-input" type="number" :placeholder="$t('lang.freightTates.weightPlaceholder')" />
          <p>KG</p>
        </div>
        <div class="volume-box">
          <p>{{ $t('lang.freightTates.volumeLabel') }}</p>
          <div style="display: flex; align-items: center;">
            <input v-model="params.long" class="volume-input" type="number" :placeholder="$t('lang.freightTates.volumeLong')" />
            <p>*</p>
            <input v-model="params.wide" class="volume-input" type="number" :placeholder="$t('lang.freightTates.volumeWide')" />
            <p>*</p>
            <input v-model="params.tall" class="volume-input" type="number" :placeholder="$t('lang.freightTates.volumeTall')" />
            <p>CM</p>
          </div>
        </div>
      </div>
      <p @click="imputedPrice" class="btn-query">{{ $t('lang.freightTates.queryBtn') }}</p>
    </div>
  </div>
</template>
<script>
import { commonList as getFareList } from '@/plugins/prices'
import { commonList as getOriginList } from '@/plugins/origins'
import { commonList as getDestinationList } from '@/plugins/destinations'
export default {
  name: 'freightTates',
  data () {
    return {
      params: { begin: '', end: '', weight: '', long: '', wide: '', tall: '' },
      originList: [],
      destinationList: [],
      fareList: [],
      result: null
    }
  },
  computed: {
    // 过滤后的始发地列表
    filteredOrigins () {
      let list = []
      // 如果没有选择目的地，显示所有始发地
      if (!this.params.end) {
        list = this.originList
      } else {
        // 如果已选择目的地，从价格列表中筛选出该目的地对应的始发地
        const availableOriginIds = this.fareList.filter(item => item.destinations_id === this.params.end).map(item => item.origins_id)
        // 从始发地列表中筛选出匹配的
        list = this.originList.filter(origin => availableOriginIds.includes(origin.id))
      }
      // 按字母顺序排序
      return list.slice().sort((a, b) => {
        return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
      })
    },
    // 过滤后的目的地列表
    filteredDestinations () {
      let list = []
      // 如果没有选择始发地，显示所有目的地
      if (!this.params.begin) {
        list = this.destinationList
      } else {
        // 如果已选择始发地，从价格列表中筛选出该始发地对应的目的地
        const availableDestinationIds = this.fareList.filter(item => item.origins_id === this.params.begin).map(item => item.destinations_id)
        // 从目的地列表中筛选出匹配的
        list = this.destinationList.filter(dest => availableDestinationIds.includes(dest.id))
      }
      // 按字母顺序排序
      return list.slice().sort((a, b) => {
        return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
      })
    }
  },
  created () {
    this.getFareList()
  },
  mounted () {
    this.$store.commit('setPageNow', 'freightTates')
  },
  methods: {
    async getFareList () { // 获取价格
      const params = { list_type: 1, data: { item_delete: 1, item_state: 1 }, order: { order_num: 'desc' } }
      const origin = await getOriginList(params)
      const destination = await getDestinationList(params)
      const fareList = await getFareList(params)
      // 创建映射表，方便快速查找
      const originMap = {}
      const destinationMap = {}
      origin.data.map(item => {
        originMap[item.origins_id] = item
      })
      destination.data.map(item => {
        destinationMap[item.destinations_id] = item
      })
      // 给fareList.data添加名称，统一处理 ID 类型
      this.fareList = (fareList.data || []).map(item => ({
        ...item,
        origins_name: originMap[item.origins_id]?.origins_name || '',
        destinations_name: destinationMap[item.destinations_id]?.destinations_name || ''
      }))
      // 整理this.fareList中的始发地数据并存储到this.originList中并去重
      this.originList = [...new Set(this.fareList.map(item => item.origins_id))].map(id => ({
        id,
        name: originMap[id]?.origins_name || ''
      }))
      this.destinationList = [...new Set(this.fareList.map(item => item.destinations_id))].map(id => ({
        id,
        name: destinationMap[id]?.destinations_name || ''
      }))
    },
    imputedPrice () { // 计算价格
      const obj = {
        begin: this.$t('lang.freightTates.errorOrigin'),
        end: this.$t('lang.freightTates.errorDestination'),
        weight: this.$t('lang.freightTates.errorWeight'),
        long: this.$t('lang.freightTates.errorLong'),
        wide: this.$t('lang.freightTates.errorWide'),
        tall: this.$t('lang.freightTates.errorTall')
      }
      const keys = Object.keys(this.params)
      for (let i = 0; i < keys.length; i++) {
        if (!this.params[keys[i]]) {
          this.$layer.msg(obj[keys[i]])
          return
        }
      }
      // 从fareList中找到对应的价格
      const fareItem = this.fareList.find(item => item.origins_id === this.params.begin && item.destinations_id === this.params.end)
      if (!fareItem) {
        this.$layer.msg(this.$t('lang.freightTates.errorNoPrice'))
        return
      }
      const cmToM = v => Math.max(0, Number(parseFloat(v) || 0)) / 100
      // 将长宽高转换为米（输入为厘米）
      const longMeter = cmToM(this.params.long)
      const wideMeter = cmToM(this.params.wide)
      const tallMeter = cmToM(this.params.tall)
      // 计算体积（立方米），保留 2 位小数
      const volumeCubicMeter = Number((longMeter * wideMeter * tallMeter).toFixed(2))
      // 计算体积重量：体积除以 0.006，保留 2 位小数
      const volumeWeight = Number((volumeCubicMeter / 0.006).toFixed(2))
      // 原始重量保留 2 位小数
      const weight = Number(Math.max(0, Number(parseFloat(this.params.weight)) || 0).toFixed(2))
      const chargeableWeight = Math.max(weight, volumeWeight)
      const pricePerKg = (Number(fareItem?.prices_value) || 0) / 100
      const totalPrice = Number((chargeableWeight * pricePerKg).toFixed(2))
      // 设置结果
      this.result = {
        originName: fareItem.origins_name,
        destinationName: fareItem.destinations_name,
        weight: this.params.weight,
        long: this.params.long,
        wide: this.params.wide,
        tall: this.params.tall,
        transitTime: fareItem.voyage_info || '',
        price: totalPrice.toFixed(2)
      }
      this.$nextTick(() => {
        if (this.$refs.resultBlock) {
          this.$refs.resultBlock.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.freightTates-box {
  background-color: #f7f9fc;
}

.top-block {
  position: relative;
  width: 1920px;
  height: 500px;
}

.top-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.top-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 220px;
  padding-left: 160px;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 70px;
  color: #FFFFFF;
}

.middle-block {
  background-color: #FFFFFF;
  padding: 60px 345px;
}

.begin-box,
.end-box {
  width: 1230px;
  height: 88px;
  background: #FFFFFF;
  border: 1px solid #989999;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 22px;
  line-height: 88px;
  color: #333333;
  padding: 0 50px 0 20px;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-image: none;
  outline: none;
}

.end-box {
  margin-top: 30px;
}

.begin-block,
.end-block {
  position: relative;
}

.begin-block::after,
.end-block::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 30px;
  /* 控制箭头的左右位置 */
  transform: translateY(-50%) rotate(45deg);
  width: 8px;
  /* 箭头大小 */
  height: 8px;
  border-right: 2px solid #666;
  border-bottom: 2px solid #666;
  pointer-events: none;
}

.end-block::after {
  top: calc(50% + 15px);
}

.end-box:required:invalid,
.begin-box:required:invalid {
  color: gray;
}

.end-box option[value=""][disabled],
.begin-box option[value=""][disabled] {
  display: none;
}

.end-box option,
.begin-box option {
  color: inherit;
}

.volume-block {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1230px;
}

.weight-box {
  width: 600px;
  height: 88px;
  background: #FFFFFF;
  border: 1px solid #989999;
  box-sizing: border-box;
  padding: 0 20px;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  line-height: 88px;
  display: flex;
  align-items: center;
}

.weight-input {
  flex: 1;
  margin-right: 10px;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  border: none;
  outline: none;
  height: 100%;
}

.volume-box {
  width: 600px;
  height: 88px;
  background: #FFFFFF;
  border: 1px solid #989999;
  box-sizing: border-box;
  padding: 0 20px;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  line-height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.volume-input {
  width: 120px;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  border: none;
  outline: none;
  height: 100%;
  text-align: center;
}

.btn-query {
  margin: 60px auto 0;
  width: 600px;
  height: 88px;
  border: none;
  border-radius: 52px;
  background: linear-gradient(135deg, #1a73e8 0%, #42a5f5 100%);
  box-shadow: 0 18px 38px rgba(26, 115, 232, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 26px;
  letter-spacing: 0.04em;
  color: #FFFFFF;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.btn-query:hover {
  transform: translateY(-4px);
  box-shadow: 0 22px 44px rgba(26, 115, 232, 0.32);
}

.btn-query:active {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(26, 115, 232, 0.32);
  filter: brightness(0.95);
}

.result-block {
  margin-bottom: 48px;
  padding: 36px 48px 44px;
  background: linear-gradient(135deg, rgba(26, 115, 232, 0.08) 0%, rgba(26, 115, 232, 0.02) 100%);
  border: 1px solid rgba(26, 115, 232, 0.12);
  border-radius: 28px;
  box-shadow: 0 26px 48px rgba(16, 36, 87, 0.12);
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
}

.result-title-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.result-subtitle {
  margin: 0;
  font-size: 16px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(26, 43, 79, 0.65);
}

.result-title {
  margin: 0;
  font-weight: 700;
  font-size: 34px;
  color: #1a2b4f;
}

.result-price-chip {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 28px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(26, 115, 232, 0.18);
  box-shadow: 0 16px 32px rgba(18, 72, 161, 0.15);
}

.result-price-chip span {
  font-size: 15px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(26, 43, 79, 0.65);
}

.result-price-chip strong {
  font-size: 26px;
  font-weight: 700;
  color: #185abc;
}

.result-divider {
  width: 100%;
  height: 1px;
  margin: 30px 0 26px;
  background: linear-gradient(90deg, rgba(26, 115, 232, 0) 0%, rgba(26, 115, 232, 0.32) 50%, rgba(26, 115, 232, 0) 100%);
}

.result-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 18px;
}

.result-list > div {
  padding: 18px 22px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(26, 115, 232, 0.12);
  box-shadow: 0 18px 34px rgba(16, 36, 87, 0.08);
}

.result-head {
  margin: 0;
  font-size: 14px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(26, 43, 79, 0.58);
}

.result-item {
  margin: 12px 0 0;
  font-weight: 600;
  font-size: 22px;
  color: #122549;
  word-break: break-word;
}

.result-fade-enter-active,
.result-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.result-fade-enter-from,
.result-fade-leave-to {
  opacity: 0;
  transform: translateY(-26px);
}
</style>
